const contentRegionMap = {
	AL: 2,
	AK: 3,
	AZ: 4,
	AR: 5,
	CA: 6,
	CO: 9,
	CT: 10,
	DE: 11,
	DC: 12,
	FL: 13,
	GA: 14,
	HI: 15,
	ID: 16,
	IL: 17,
	IN: 18,
	IA: 19,
	KS: 20,
	KY: 21,
	LA: 22,
	ME: 23,
	MD: 24,
	MA: 25,
	MI: 26,
	MN: 27,
	MS: 28,
	MO: 29,
	MT: 30,
	NE: 31,
	NV: 32,
	NH: 33,
	NJ: 34,
	NM: 35,
	NY: 36,
	NC: 37,
	ND: 38,
	OH: 39,
	OK: 40,
	OR: 41,
	PA: 42,
	RI: 43,
	SC: 44,
	SD: 45,
	TN: 46,
	TX: 47,
	UT: 48,
	VA: 49,
	VT: 53,
	WA: 54,
	WV: 55,
	WI: 56,
	WY: 57,
	US: 1,
};

export const contentSpecialtyMap = {
	acu: 1,
	dc: 2,
	nd: 3,
	rd: 4,
	pd: 5,
	pdm: 5,
	rtm: 7,
	rt: 8,
	mt: 9,
	vptr: 10,
};

export const regionMap = {
	AL: 260,
	AK: 110,
	AZ: 520,
	AR: 380,
	CA: 670,
	CO: 720,
	CT: 800,
	DE: 130,
	DC: 930,
	FL: 200,
	GA: 490,
	HI: 630,
	ID: 880,
	IL: 990,
	IN: 180,
	IA: 780,
	KS: 240,
	KY: 350,
	LA: 400,
	ME: 740,
	MD: 650,
	MA: 500,
	MI: 900,
	MN: 150,
	MS: 420,
	MO: 220,
	MT: 590,
	NE: 840,
	NV: 330,
	NH: 970,
	NJ: 190,
	NM: 280,
	NY: 470,
	NC: 600,
	ND: 760,
	OH: 550,
	OK: 690,
	OR: 710,
	PA: 850,
	RI: 250,
	SC: 300,
	SD: 450,
	TN: 530,
	TX: 610,
	UT: 730,
	VA: 890,
	VT: 100,
	WA: 210,
	WV: 410,
	WI: 370,
	WY: 560,
	US: 872,
};

export const specialtyMap = {
	acu: 23,
	dc: 17,
	nd: 51,
	rd: 48,
	pd: 87,
	pdm: 94,
	rtm: 75,
	rt: 62,
	mt: 36,
	vptr: 67,
};

export const mapRegionSpecialtyString = regionSpecialtyString => {
	// remove numeric characters from string
	const regionSpecialtyOnly = regionSpecialtyString.replace(/\d+/g, '');
	const region = regionSpecialtyOnly.substring(0, 2);
	const specialty = regionSpecialtyOnly.substring(2);
	return {
		specialty: contentSpecialtyMap[specialty],
		region: contentRegionMap[region],
	};
};

export const validRegionSpecialtyString = regionSpecialtyString => {
	// remove numeric characters from string
	const letters = regionSpecialtyString.replace(/\d+/g, '');
	const region = letters.substring(0, 2);
	const specialty = letters.substring(2);
	// remove non-numeric characters from string
	const digits = regionSpecialtyString.replace(/\D+/g, '');
	const regionCode = parseInt(digits.substring(0, 3), 10);
	const specialtyCode = parseInt(digits.substring(3), 10);
	return (
		regionMap[region] === regionCode &&
		specialtyMap[specialty] === specialtyCode
	);
};
